module.exports = __webpack_public_path__ + "bae1fcd0a710badbc34e3eefc964c585.png";